// extracted by mini-css-extract-plugin
export default {"home":"support_home__DG7Dh","home2":"support_home2__EZi3H","main":"support_main__8IQVX"};